import React from "react";
import Section from "./Section";

export default function HTML_Headings() {
  return (
    <div className="tutorial-container">
      {/* 🔹 Title */}
      <h1 className="tutorial-title">🔠 HTML Headings</h1>

      {/* 🔹 Introduction */}
      <div
        style={{
          background: "linear-gradient(135deg, #fef3c7, #fde68a)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "1.5rem",
          marginBottom: "2rem",
        }}
      >
        <p className="tutorial-intro">
          HTML <strong>headings</strong> are used to define titles and subtitles
          on a webpage. They range from <code>&lt;h1&gt;</code> (most important)
          to <code>&lt;h6&gt;</code> (least important).
        </p>
      </div>

      {/* Section — Example of All Headings */}
      <Section
        title="🔹 Example of All HTML Headings"
        html={`<!DOCTYPE html>
<html>
  <head>
    <title>HTML Headings Example</title>
  </head>
  <body>
    <h1>This is Heading 1</h1>
    <h2>This is Heading 2</h2>
    <h3>This is Heading 3</h3>
    <h4>This is Heading 4</h4>
    <h5>This is Heading 5</h5>
    <h6>This is Heading 6</h6>
  </body>
</html>`}
        description="HTML has six levels of headings. <h1> defines the main title of the page, and <h6> defines the least important heading."
      />

      {/* 🔹 Description Points */}
      <ul className="tutorial-list-points">
        <li>
          <strong>&lt;h1&gt;</strong> — Main page title (used once per page)
        </li>
        <li>
          <strong>&lt;h2&gt;</strong> — Section heading under the main title
        </li>
        <li>
          <strong>&lt;h3&gt;</strong> — Subsection under &lt;h2&gt;
        </li>
        <li>
          <strong>&lt;h4&gt;</strong> — Used for smaller subtopics
        </li>
        <li>
          <strong>&lt;h5&gt;</strong> — Minor heading
        </li>
        <li>
          <strong>&lt;h6&gt;</strong> — Least important heading
        </li>
      </ul>

      {/* 🔹 Best Practices */}
      <div
        style={{
          background: "linear-gradient(135deg, #d1fae5, #a7f3d0)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2>✅ Best Practices</h2>
        <ul className="tutorial-list-points">
          <li>Use only one &lt;h1&gt; per page.</li>
          <li>Follow proper order (don’t skip from h1 to h4).</li>
          <li>Headings should describe the section that follows.</li>
          <li>Use CSS to style — not for heading hierarchy.</li>
        </ul>
      </div>

      {/* 🔹 Summary */}
      <div
        style={{
          background: "linear-gradient(135deg, #e0f2fe, #bae6fd)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2>📘 Summary</h2>
        <ul className="tutorial-list-points">
          <li>HTML provides six heading tags — from h1 to h6.</li>
          <li>h1 is the largest and most important heading.</li>
          <li>Headings help structure and organize content.</li>
          <li>They improve both accessibility and SEO.</li>
        </ul>
      </div>
    </div>
  );
}
